module.exports = __webpack_public_path__ + "fonts/fontawesome-webfont.a3de2170.ttf";